export interface IManualAdjustment {
  id: number;
  journeyId: number;
  amount: number;
  vatLevel: number;
  description: string;
  created: string;
  createdByUser: ICreatedByUser;
  createdForOrganization: ICreatedForOrganization;
  type: string;
  invoiceId: number;
  invoiceLineId: number;
  currency: string;
}

export interface ICreatedByUser {
  id: number;
  name: string;
}

export interface ICreatedForOrganization {
  id: number;
  name: string;
}

export enum ManualAdjustmentType {
  Refund = 'REFUND',
  Reclamation = 'RECLAMATION',
  Compensation = 'COMPENSATION',
  FinancialError = 'FINANCIAL_ERROR',
}

export const ManualAdjustmentTypeDisplayName = {
  [ManualAdjustmentType.Refund]: 'Refund',
  [ManualAdjustmentType.Reclamation]: 'Reclamation',
  [ManualAdjustmentType.Compensation]: 'Compensation',
  [ManualAdjustmentType.FinancialError]: 'Financial error',
}
